/**
 * AI 思考消息处理器
 */
import { isAiThinkingType } from '../../message-utils';
import type { StreamMessageHandler, StreamMessageData, HandlerContext } from '../types';

/**
 * AI 思考消息处理器
 * 处理 AI 思考类型的流式消息，所有 AI 思考类型都追加到同一个消息中
 */
export const aiThinkingHandler: StreamMessageHandler = {
  name: 'ai-thinking',

  canHandle(data: StreamMessageData): boolean {
    return isAiThinkingType(data.tool_key);
  },

  handle(data: StreamMessageData, ctx: HandlerContext): boolean {
    const { tool_key, streaming_content, tool_state, content } = data;
    const isCompleted = tool_state === 'completed';

    // completed 时使用 content.raw 作为完整内容，running 时累积 streaming_content
    const fullContent =
      content && typeof (content as { raw?: string }).raw === 'string'
        ? (content as { raw: string }).raw
        : undefined;

    ctx.messageUpdater.updateStreamingMessage(
      streaming_content ?? '',
      tool_key,
      isCompleted,
      fullContent,
    );

    return false;
  },
};
